import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Typography,
} from '@mui/material'
import React, { FC, PropsWithChildren, ReactNode } from 'react'
import { getImageSrc } from '../../../../helpers/getImageSrc'

interface INewCustomAccordion {
  openIndex: number
  setOpenIndex: (idx: number) => void
  withCheckbox?: boolean
  index: number
  headColor: string
  headTitle: string | ReactNode
  checked?: boolean
  onCheck?: () => void
}

const NewCustomAccordion: FC<PropsWithChildren<INewCustomAccordion>> = (
  props,
) => {
  const {
    index,
    openIndex,
    setOpenIndex,
    withCheckbox,
    headColor,
    headTitle,
    checked,
    onCheck,
    children,
  } = props

  const onChange = () => {
    if (index === openIndex) {
      setOpenIndex(-1)
    } else {
      setOpenIndex(index)
    }
  }

  return (
    <Accordion
      expanded={openIndex === index}
      onChange={onChange}
      sx={getAccordionSx(openIndex === index, headColor)}
    >
      <AccordionSummary
        expandIcon={<img src={getImageSrc('shevronDown')} />}
        sx={summarySx}
      >
        <Box className={'jst-sb aln-center'} width={1}>
          <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
            {headTitle}
          </Typography>
          {withCheckbox && (
            <Checkbox
              checked={checked}
              onClick={(e) => e.stopPropagation()}
              onChange={onCheck}
            />
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: 0,
          backgroundColor: '#fff',
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

const getAccordionSx = (isOpen: boolean, headColor?: string) => ({
  backgroundColor: headColor ? headColor : '#EDF1F5',
  color: 'rgba(0, 0, 0, 0.87)',

  '&.MuiPaper-root': {
    boxShadow: 'none !important',
    margin: '0!important',
  },
  '.MuiAccordionSummary-content': {
    margin: '4px 0 !important',
  },
  '.MuiButtonBase-root.MuiAccordionSummary-root': {
    minHeight: '48px!important',
  },
  '.MuiAccordionSummary-expandIconWrapper': {
    transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
  },
})

const summarySx = {
  opacity: '1 !important',
  flexDirection: 'row-reverse',
  gap: '8px',
}

export default NewCustomAccordion
